import React, { FC, PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";
import useAuthentication from "../hooks/useAuthentication";
import Loading from "./Loading";

interface RequireAuthProps extends PropsWithChildren {
  /** The path to navigate to if authentication failed */
  loginPath: string;
}

/**
 * Wrapper for protected content
 *
 * If user is undefined, there could be two reasons: either it's the initial page load
 * and we are still loading the user object, or the user is not authenticated, so we discriminate these
 * two cases, and only return the children if the user object is available.
 *
 */
const RequireAuth: FC<RequireAuthProps> = ({ loginPath, children }) => {
  const { user, isLoadingMainAccountData } = useAuthentication();

  if (!user) {
    if (!isLoadingMainAccountData) {
      return <Navigate to={loginPath} />;
    } else {
      return <Loading />;
    }
  }

  return <>{children}</>;
};

export default RequireAuth;
